import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface ListHeaderProps {
  cols: Array<number | string>;
  labels: ReactNode[];
  className?: string;
}

export function ListHeader({ cols, labels, className }: ListHeaderProps) {
  const gridTemplateColumns = cols
    .map(c => (typeof c === 'number' ? `${c}px` : c))
    .join(' ');
  const style: CSSProperties = { gridTemplateColumns };
  return (
    <div
      style={style}
      className={cn(
        'grid gap-2 flex-shrink-0',
        'pl-3 pr-[14px] py-1.5 bg-surfaceAlt border-b border-border',
        className
      )}
    >
      {labels.map((l, i) => (
        <div
          key={i}
          className={cn(
            'font-mono text-[9.5px] font-bold uppercase tracking-[.08em] text-textMute',
            'flex items-center',
            i > 1 ? 'justify-end text-right' : 'justify-start text-left'
          )}
        >
          {l}
        </div>
      ))}
    </div>
  );
}

ListHeader.displayName = 'ListHeader';

export default ListHeader;
